import Cookies from "js-cookie";
import { stringComparison } from "./app-utils";

/**
 * Checks whether the current session's business unit cookie matches the
 * given business unit (by name or id). Enterprise Admins bypass this
 * check — they may access any BU.
 *
 * Extracted from EditBusinessUnit so institution views can reuse the
 * same authorization gate without duplicating logic.
 */
export function isSessionBusinessUnitAllowed(data: {
  businessUnitName?: string;
  businessUnitId?: string;
  BusinessUnitName?: string;
  BusinessUnitId?: string;
} | null | undefined): boolean {
  if (!data) return false;
  const sessionBu = (Cookies.get("businessUnit") ?? "").trim();
  if (!sessionBu) return false;
  const buName = (data.businessUnitName ?? data.BusinessUnitName ?? "").trim();
  const buId = (data.businessUnitId ?? data.BusinessUnitId ?? "").trim();
  return (
    stringComparison(buName, sessionBu) ||
    stringComparison(buId, sessionBu)
  );
}
